import PakViewModel from './pakviewmodel';
import SupplyViewModel from './supplyviewmodel';

const productTypes = {
    SMARTPAK: 1,
    SUPPLY: 2,
    PORTIONPAK: 3
};

export default function cartItemViewModelFactory(model, customerIsSmartPrimeEligible, onAutoShipUpdate) {
    var vm,
        mixins = {
            isSupply: model.ProductType === productTypes.SUPPLY,
            isSmartPak: model.ProductType === productTypes.SMARTPAK,
            isPortionPak: model.ProductType === productTypes.PORTIONPAK,
            animalType: animalType(model.AnimalTypeId)
        };

    if (model.ProductType === productTypes.SUPPLY) {
        vm = new SupplyViewModel(model, customerIsSmartPrimeEligible, onAutoShipUpdate);
    } else {
        vm = new PakViewModel(model, onAutoShipUpdate);
    }

    return $.extend(vm, mixins);
}

function animalType(type) {
    var HORSE = 1,
        DOG = 2;

    return type === HORSE ? 'horse' : type === DOG ? 'dog' : '';
}

